import { settingsService } from "../../api/settingsService/settingsService";
import { IsAuthorized } from "../../utils/helpers/auth";

export const getSettingsData = async () => {
    if (IsAuthorized()) {
        const contactsRes = await settingsService.getContacts();    

        if (contactsRes.success) {
            return {
                settingsApi: contactsRes.responseBody.contacts,
            }
        } else {
            console.log('error');
        }
    } else {
        return {
            settingsApi: []
        }
    }    
}